import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import ReactSelect, { components } from 'react-select'
import styles from './index.module.scss'

export default function UnderlineSelect ({
  className,
  options,
  isMulti,
  onChange,
  components: customComponents,
  isClearable,
  removeSelected,
  defaultValue,
  placeholder,
  isDisabled = false,
  closeMenuOnSelect = false,
  isSearchable = false,
  enableSelectAll,
  isError = false,
  minWidth = 350,
  maxWidth = 350,
  inputId
}) {
  const selectRef = useRef(null)
  const handleCloseDropdown = () => {
    if (selectRef.current) {
      selectRef.current.blur()
    }
  }

  useEffect(() => {
    isError && handleCloseDropdown()
  }, [isError])
  const CustomDropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <div
        className={styles.customDropDownStyle}
      />
    </components.DropdownIndicator>
  )
  const customStyle = {
    container: (provided) => ({
      ...provided,
      outline: 'none',
      pointerEvents: 'unset'
    }),
    control: (provided, state) => ({
      ...provided,
      maxWidth,
      minWidth,
      display: 'flex',
      flexDirection: 'row',
      border: 'none',
      borderBottom: `${state.isFocused ? '3px solid #33CA80' : '1px solid #ccc'}`,
      boxSizing: 'border-box',
      borderRadius: 0,
      boxShadow: 'none',
      backgroundColor: 'transparent',
      minHeight: '37px',
      alignItems: 'center',
      fontSize: '14px',
      cursor: isDisabled ? 'not-allowed' : 'pointer'
    }),
    valueContainer: (base) => ({
      ...base,
      display: 'flex',
      flexWrap: 'nowrap',
      overflowX: 'auto',
      scrollbarWidth: '60px',
      msOverflowStyle: 'auto',
      maxHeight: '40px',
      paddingRight: '8px',
      alignItems: 'center'
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#555',
      margin: 0,
      padding: 0
    }),
    indicatorSeparator: () => ({
      display: 'none'
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#000',
      padding: '0 6px'
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#fff',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      border: '0.75px solid #000',
      borderTop: '2px solid #ccc',
      borderRadius: 0,
      zIndex: 9999,
      marginTop: 0
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected || state.isFocused ? '#0062cc' : '#fff',
      color: state.isSelected || state.isFocused ? '#fff' : '#000',
      padding: '2px 2px',
      fontSize: '14px',
      marginTop: -5
    }),
    multiValue: (base) => ({
      ...base,
      whiteSpace: 'nowrap',
      marginRight: '4px',
      maxWidth: '100%',
      flexShrink: 0
    })
  }
  return (
    <ReactSelect
      inputId={inputId}
      className={cn(className, styles.selectBox)}
      classNamePrefix='custom'
      styles={customStyle}
      isMulti={isMulti}
      components={{
        ...customComponents,
        DropdownIndicator: CustomDropdownIndicator
      }}
      options={enableSelectAll ? [{ label: 'All', value: 'all' }, ...options] : options}
      onChange={(selectedValues) => {
        const isAll = isMulti && selectedValues?.find(option => option.value === 'all')
        if (isAll && enableSelectAll) {
          selectedValues = options
        }
        onChange(isMulti ? (selectedValues || []) : selectedValues)
      }}
      isClearable={isClearable}
      hideSelectedOptions={removeSelected}
      value={defaultValue}
      isDisabled={isDisabled}
      closeMenuOnSelect={closeMenuOnSelect}
      isSearchable={isSearchable}
      placeholder={`${placeholder}`}
      ref={selectRef}
    />
  )
}

UnderlineSelect.defaultProps = {
  isMulti: false,
  placholder: '',
  components: null,
  isClearable: true,
  removeSelected: true,
  enableSelectAll: false
}

UnderlineSelect.propTypes = {
  className: PropTypes.string,
  options: PropTypes.array.isRequired,
  isMulti: PropTypes.bool,
  enableSelectAll: PropTypes.bool,
  onChange: PropTypes.func,
  components: PropTypes.object,
  isClearable: PropTypes.bool,
  removeSelected: PropTypes.bool,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.any,
  isDisabled: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isError: PropTypes.bool,
  minWidth: PropTypes.number,
  maxWidth: PropTypes.number,
  inputId: PropTypes.string
}
